import { useIntl } from 'react-intl'
import _get from 'lodash/get';
import Card from '@/entities/Card';
import { PayoutsIncomeChart } from '~/accountingAndAnonymous/Payouts';
import TextBlock from '@/shared/ui/TextBlock';
import { useMinerAccount } from "@/processes/MinerAccounts";
import { useCryptoFormatter } from '@/processes/PoolStats';
import { useGetDailyEarningsQuery } from '@/shared/api/Stats';

type PayoutsIncomeChartWidgetProps = {
  className: string;
}

const PayoutsIncomeChartWidget = (props: PayoutsIncomeChartWidgetProps) => {
  const { className } = props;
  const intl = useIntl();
  const { account, miner, coin } = useMinerAccount();
  const { formatCryptoAmount } = useCryptoFormatter({ coin })

  const {
    data: estDailyEarnings,
    isSuccess: isDailyEarningsIdSuccess
  } = useGetDailyEarningsQuery({ account, coin, miner }, { skip: !(account || miner)})

  return (
    <Card
      className={className}
      title={intl.formatMessage({ id: 'payouts.income' })}
    >
      <div className="flex my-4 -mx-4">
        <TextBlock
          isLoading={!isDailyEarningsIdSuccess}
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'stats.est.earnings' })}
          value={formatCryptoAmount(_get(estDailyEarnings, 'amount'))}
          subValue={coin}
        />
        <TextBlock
          isLoading={!isDailyEarningsIdSuccess}
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'stats.est.week.earnings' })}
          value={formatCryptoAmount(_get(estDailyEarnings, 'amount') * 7)}
          subValue={coin}
        />
      </div>

      <PayoutsIncomeChart/>
    </Card>
  );
}

export default PayoutsIncomeChartWidget;
